import Route from '@ember/routing/route';

export default class HotelStrategyPositionRoute extends Route {
  queryParams = {
    sortBy: {
      refreshModel: false,
    },
    sortDirection: {
      refreshModel: false,
    },
  };
}
